import type { VodDto } from '@bldsoft/cappie/api/wbs'
import type {
  MediaOrderType,
  PurchaseInfoContentPurchaseType,
  Vod,
  VodUpdated,
} from '@setplex/tria-api'

import {
  MediaTypes,
  PurchaseInfoContentPurchaseType as PurchaseInfoContentPurchaseTypeEnum,
} from '@setplex/tria-api'
import {
  getBackgroundImage,
  getHorizontalImage,
  getVerticalImage,
} from '../../utils/images'
import {
  formatDuration,
  formatResolution,
  humanizeLengthWithoutSeconds,
} from '../../utils/media'
import { formatPriceSettings } from '../../utils/payment'

export const formatVod = ({
  imageHorizontalUrl,
  imageUrl,
  imageBackgroundUrl,
  resolution,
  length,
  watched,
  favorite,
  orderType,
  free,
  priceSettings,
  stoppedTime,
  ...rest
}: Omit<VodDto, 'contentType'>): Vod => {
  const purchaseInfo =
    rest.purchaseInfo?.contentPurchaseType || rest.purchaseInfo?.rentedUntil
      ? {
          contentPurchaseType: rest.purchaseInfo
            ?.contentPurchaseType as PurchaseInfoContentPurchaseType,
          rentedUntil: rest.purchaseInfo?.rentedUntil,
        }
      : undefined

  return {
    ...rest,
    id: rest.id!,
    trailerPresent: rest.trailerPresent!,
    imageHorizontalUrl: getHorizontalImage(imageHorizontalUrl),
    imageBackgroundUrl: getBackgroundImage(imageBackgroundUrl),
    imageUrl: getVerticalImage(imageUrl),
    imageMobileBackgroundUrl: getBackgroundImage(imageUrl),
    length: humanizeLengthWithoutSeconds({ length }),
    resolution: formatResolution({ resolution }),
    mediaType: MediaTypes.VOD,
    orderType: String(orderType || '').toUpperCase() as MediaOrderType,
    watched: Boolean(watched), // could be `null` from openapi, because they re-use this DTO in PATCH requests...
    favorite: Boolean(favorite), // could be `null` from openapi, because they re-use this DTO in PATCH requests...
    free: free === undefined ? true : free, // Set field free is true for Nora 1.46 version, where there is no field free
    priceSettings: formatPriceSettings(priceSettings),
    purchaseInfo,
    rented:
      purchaseInfo?.contentPurchaseType ===
      PurchaseInfoContentPurchaseTypeEnum.Rented,
    stoppedTime,
    duration: formatDuration({ length }),
    contentType: MediaTypes.VOD,
  } as Vod
}

export const formatVodUpdatedOnly = ({ id, updated }: VodDto): VodUpdated => {
  return {
    id,
    updated,
  }
}
